import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import { BuyingTeamSettingsDialog } from './components/buying-team-settings-dialog';
import * as Styled from './styles';
import * as SX from './sx';
import type { BuyingTeamsMatrixProps as Props } from './types';

export const BuyingTeamMatrix = memo(({ className }: Props) => {
  return (
    <>
      <BuyingTeamSettingsDialog />
      {/* <BuyingTeamNewPersonaDialog /> */}
      {/* <BuyingTeamNewPersonaConfirmDialog /> */}
      <Styled.Wrapper
        className={classnames('BuyingTeamMatrix', className)}
        sx={SX.root}
      >
        <Typography sx={SX.title}>Buying Team Matrix </Typography>

        <Typography sx={SX.description}>
          The Buying Team Matrix is coming soon!
        </Typography>

        {/* TODO  comment this for showing in OKR */}
        {/* <BuyingTeamMatrixCardHeader
          title={
            <Typography variant="body2">Buying Team Matrix</Typography>
          }
        />
        <BuyingTeamsMatrixCardList /> */}
      </Styled.Wrapper>
    </>
  );
});

BuyingTeamMatrix.displayName = 'BuyingTeamMatrix';
